import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import ExpenseCategoryService from '../services/ExpenseCategoryService';

const initialState = {
  data: [],
  datas: [],
  parent_datas: [],
  formError: [],
  pagination: {
    page: 0,
    per_page: 10,
    total: 10,
    totalPages: 10,
  },
  error: null,
  status: '',
  loading: false,
  submitLoading: false,
};

export const expenseCategoryList = createAsyncThunk(
  'expenseCategory/list',
  async ({ perPage, page, keyword }) => {
    try {
      const resp = await ExpenseCategoryService.List({ perPage, page, keyword });
      return resp;
    } catch (e) {
      return e.response;
    }
  },
);

export const parentExpenseCategories = createAsyncThunk(
  'expenseCategory/parentExpenseCategories',
  async ({ perPage, page, keyword, type = '' }) => {
    try {
      const resp = await ExpenseCategoryService.List({ perPage, page, keyword, type });
      return resp;
    } catch (e) {
      return e.response;
    }
  },
);

export const expenseCategoryAdd = createAsyncThunk('expenseCategory/add', async (data) => {
  try {
    const resp = await ExpenseCategoryService.Create(data);
    return resp;
  } catch (e) {
    return e.response;
  }
});

export const expenseCategoryEdit = createAsyncThunk(
  'expenseCategory/edit',
  async ({ id, data }) => {
    try {
      const resp = await ExpenseCategoryService.Put(id, data);
      return resp;
    } catch (e) {
      return e.response;
    }
  },
);

export const expenseCategoryDelt = createAsyncThunk('expenseCategory/delt', async (id) => {
  try {
    const resp = await ExpenseCategoryService.Delt(id);
    return resp;
  } catch (e) {
    return e.response;
  }
});

const expenseCategoryAction = createSlice({
  name: 'expenseCategory',
  initialState: initialState,
  extraReducers: (builder) => {
    builder
      .addCase(expenseCategoryList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(expenseCategoryList.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          state.datas = [...action.payload?.data.data];
          state.pagination = action.payload?.data.pagination;
        } else {
          state.error = action.payload?.data.message;
          toast.error(state.error);
        }
        state.loading = false;
      })
      .addCase(expenseCategoryList.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.loading = false;
      })
      .addCase(parentExpenseCategories.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(parentExpenseCategories.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          state.parent_datas = [...action.payload?.data.data];
          state.pagination = action.payload?.data.pagination;
        } else {
          state.error = action.payload?.data.message;
          toast.error(state.error);
        }
        state.loading = false;
      })
      .addCase(parentExpenseCategories.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.loading = false;
      })
      .addCase(expenseCategoryAdd.pending, (state, action) => {
        state.submitLoading = true;
      })
      .addCase(expenseCategoryAdd.fulfilled, (state, action) => {
        state.status = '';
        if (action.payload?.status === 200) {
          state.datas.unshift(action.payload.data.data);
          state.info = action.payload?.data.message;
          state.status = 'achieve';
          toast.success(action.payload?.data.message);
        } else {
          toast.error(action.payload?.data.errors);
        }
        state.formError = action.payload?.data.errors;
        state.submitLoading = false;
      })
      .addCase(expenseCategoryAdd.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.submitLoading = false;
      })
      .addCase(expenseCategoryEdit.pending, (state, action) => {
        state.info = '';
        state.submitLoading = true;
      })
      .addCase(expenseCategoryEdit.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          state.info = action.payload?.data.message;
          const index = state.datas.findIndex(
            (client) => client.id === action.payload.data.data.id,
          );
          state.datas[index] = {
            ...state[index],
            ...action.payload.data.data,
          };
          toast.success(action.payload?.data.message);
        } else {
          toast.error(action.payload?.data.errors);
        }
        state.submitLoading = false;
      })
      .addCase(expenseCategoryEdit.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.submitLoading = false;
      })
      .addCase(expenseCategoryDelt.pending, (state, action) => {
        state.info = '';
        state.submitLoading = true;
      })
      .addCase(expenseCategoryDelt.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          let index = state.datas.findIndex(({ id }) => id === action.payload.data.data.id);
          state.datas.splice(index, 1);
          state.info = action.payload?.data.message;
          toast.success(action.payload?.data.message);
        }
        state.submitLoading = false;
      })
      .addCase(expenseCategoryDelt.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.submitLoading = false;
      });
  },
});

const { reducer } = expenseCategoryAction;

export default reducer;
